"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesSelectorPropertiesFromGraphqlProperties = createPropertiesSelectorPropertiesFromGraphqlProperties;
const property_1 = require("@genesys/property");
const PropertyFilterHelpers = __importStar(require("@genesys/shared/lib/property-filter-helpers"));
const QuantityConversion = __importStar(require("@genesys/shared/lib/quantity-conversion"));
function createPropertiesSelectorPropertiesFromGraphqlProperties(productProperties, selectedProperties, skipGroupNames = false, explicitPropertyNamnes = productProperties.map(p => p.name)) {
    const explicitPropertyNamnesSet = new Set(explicitPropertyNamnes);
    const toPropertiesSelectorProperty = createToPropertiesSelectorProperty(selectedProperties, skipGroupNames);
    const selectorProperties = productProperties
        .filter(p => explicitPropertyNamnesSet.has(p.name))
        .filter(p => !p.name.startsWith("acc_"))
        .reduce(toPropertiesSelectorProperty, [])
        .sort((a, b) => a.sort_no - b.sort_no);
    return selectorProperties;
}
function createToPropertiesSelectorProperty(selectedProperties, skipGroupNames) {
    return (selectorProperties, productProperty) => {
        const property = {
            conversionParameters: QuantityConversion.createConversionParameters(productProperty.quantityConversionParams, selectedProperties),
            name: productProperty.name,
            quantity: productProperty.quantity,
            sort_no: numberOrZero(productProperty.sortNo),
            group: (!skipGroupNames && productProperty.groupName) || "",
            validation_filter: PropertyFilterHelpers.createPropertyFilter(productProperty.validationFilter, property_1.PropertyFilter.Empty),
            visibility_filter: PropertyFilterHelpers.createPropertyFilter(productProperty.visibilityFilter, property_1.PropertyFilter.Empty),
            value: productProperty.values
                .map(v => {
                const pv = {
                    value: property_1.PropertyValue.fromString(v.value),
                    sort_no: numberOrZero(v.sortNo),
                    property_filter: PropertyFilterHelpers.createPropertyFilter(v.validationFilter, property_1.PropertyFilter.Empty),
                    image: v.image || undefined
                };
                return pv;
            })
                .sort((a, b) => a.sort_no - b.sort_no)
        };
        selectorProperties.push(property);
        return selectorProperties;
    };
}
function numberOrZero(value) {
    return value !== null && value !== undefined ? value : 0;
}
//# sourceMappingURL=property-creator.js.map